import PropTypes from 'prop-types'

import { TpmsTireLocations } from '../../models/tpms/tpms-tire-locations-enum'

/**
 * @typedef {Object} TpmsTireLocation
 * @property {number} axle
 * @property {string} wheel
 */
export const tpmsTireLocationPropType = PropTypes.shape({
    axle: PropTypes.number,
    wheel: PropTypes.oneOf(Object.values(TpmsTireLocations))
})
